import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router';

import { connect, useDispatch } from 'react-redux';

import { HAIRCARE_CART_URL } from 'constants/cart';

import ErrorContainer from 'Containers/ErrorContainer';

import consultationCategoryProp from 'PropTypes/consultationProps';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import Posology from '../Scenes/Posology';

import {
  getIngredientsData,
  getIngredientsError,
  getIngredientsStatus,
} from 'dux/consultation/selectors';
import { subscriptionCategoryWithMissingConsultation } from 'dux/subscriptions/selectors';
import { getUserFirstName } from 'dux/user/selectors';
import { fetchHaircareIngredients } from 'dux/consultation/thunks';

const PosologyContainer = ({
  consultationCategory,
  error,
  ingredientsData,
  status,
  subscriptionCategoryToRedirect,
  userName,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (['idle', 'invalidated'].includes(status)) {
      dispatch(fetchHaircareIngredients());
    }
  }, [status, fetchHaircareIngredients]);

  /**
   * If the user was redirected to the consultation from an upsell subscription card
   * Redirect him to subscription from here
   * Otherwise, add preselected product to URL if needed
   */
  const nextUrl = subscriptionCategoryToRedirect
    ? `/account/subscription/${subscriptionCategoryToRedirect}`
    : HAIRCARE_CART_URL;

  switch (status) {
    case 'loading':
    case 'idle':
    case 'invalidated':
      return <ConsultationLoading />;
    case 'success':
      return (
        <Posology
          consultationCategory={consultationCategory}
          name={userName}
          posology={ingredientsData}
          submit={() => navigate(nextUrl)}
        />
      );
    case 'error':
    default:
      return (
        <ErrorContainer
          error={error}
          retry={() => dispatch(fetchHaircareIngredients())}
          sentryMessage="Invalid state on PosologyContainer"
        />
      );
  }
};

PosologyContainer.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  error: PropTypes.shape({}),
  subscriptionCategoryToRedirect: PropTypes.string,
  ingredientsData: PropTypes.arrayOf(PropTypes.shape({})),
  status: PropTypes.string.isRequired,
  userName: PropTypes.string,
};

PosologyContainer.defaultProps = {
  error: null,
  subscriptionCategoryToRedirect: null,
  ingredientsData: [],
  userName: null,
};

export default connect(
  state => ({
    error: getIngredientsError(state),
    subscriptionCategoryToRedirect: subscriptionCategoryWithMissingConsultation(state),
    ingredientsData: getIngredientsData(state),
    status: getIngredientsStatus(state),
    userName: getUserFirstName(state),
  }),
  {}
)(PosologyContainer);
